@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.fieldGroup {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.fieldLabel {
  @include typography-v2-body-sm;
  color: var(--text-default);
}

.styledDropdown {
  width: 100%;
}

.selectWrapper {
  [data-input-element] {
    cursor: pointer;
    width: 100%;
    min-height: 40px;
    height: 40px;
    box-sizing: border-box;
  }

  [data-input-wrapper] {
    @include border-radius-r2;
    min-height: 40px;
    height: 40px;
    box-sizing: border-box;
  }
}
